import 'react-toastify/dist/ReactToastify.css';
import "moment/locale/pt-br"
import { BrowserRouter } from 'react-router-dom';
import SystemRoutes from './routes';
import PrimaryColorProvider from './context/primaryColor/PrimaryColorProvider';
import DrawerThemeProvider from './context/drawerTheme/DrawerThemeProvider';
import UserProvider from './context/user/UserProvider';
import { ToastContainer } from 'react-toastify';

const App = () => {

  return (
    <BrowserRouter>
      <PrimaryColorProvider>
        <DrawerThemeProvider>
          <UserProvider>
            <SystemRoutes />
          </UserProvider>
        </DrawerThemeProvider>
      </PrimaryColorProvider>
      <ToastContainer />
    </BrowserRouter>
  );

}

export default App;